<mat-toolbar class="subtitulo">Cadastro de Documento Atividade</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <form #formCadastro="ngForm">

         <!-- ATIVIDADE -->
         <mat-toolbar class="titulopartes">Atividades</mat-toolbar>
         <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
 
              <mat-form-field  fxFlex= "55%" fxFlexOffset="20px" >
                 <mat-label>Selecione uma atividade:</mat-label>
                 <mat-select [(ngModel)]="documentoAtividade.atividade.id" 
                             (selectionChange)=mostrarDadosAtividade($event.value)
                             name="atividade" 
                             required>
                     <mat-option></mat-option>
                     <mat-option *ngFor="let m of atividades" [value]="m.id" >
                       {{m.descricao}}
                     </mat-option>
                 </mat-select>
                </mat-form-field>
 
         </div>

        <div *ngIf="documentoAtividade.atividade.id">
            <dados-atividade [atividade]="documentoAtividade.atividade"></dados-atividade>
        </div> 

        <!-- DADOS INICIAIS -->
        <mat-toolbar class="titulopartes">Dados</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

            <mat-form-field fxFlexOffset="20px" fxFlex= "45%" fxFlexOffset="20px" appearance="outline">
                <mat-label>Descrição:</mat-label>
                <textarea matInput
                      name="observacoes"
                      [(ngModel)]="documentoAtividade.descricao"
                      cdkTextareaAutosize
                      #autosize="cdkTextareaAutosize"
                      cdkAutosizeMinRows="1"
                      maxlength="200"
                      ></textarea>
             </mat-form-field>

           <!-- OBSERVAÇÕES -->
              <mat-form-field fxFlexOffset="20px" fxFlex= "45%" appearance="outline" >
                      <mat-label>Observações:</mat-label>
                      <textarea matInput
                            name="observacoes"
                            [(ngModel)]="documentoAtividade.observacao"
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="1"
                            maxlength="200"
                            ></textarea>
              </mat-form-field>
           </div>

         <!-- BOTOES -->
   <div dir="rtl" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>
    <button *ngIf="!isAtualizar && mostrarBotaoCadastrar" mat-raised-button
            name="botaoConfirmar"
            fxFlex="20%"
            color="primary"
            [disabled]="formCadastro.invalid"
            (click)="cadastrar()"> Cadastrar
    </button>

    <button *ngIf="isAtualizar && mostrarBotaoAtualizar" mat-raised-button
            name="botaoConfirmar"
            fxFlex="20%"
            color="primary"
            [disabled]="formCadastro.invalid"
            (click)="atualizar()">
            Atualizar
    </button>

    <button *ngIf="mostrarBotaoLimpar()" 
            mat-raised-button 
            fxFlex="20%" 
            (click)="limpar()">
            Limpar
    </button>
    <button 
            mat-raised-button 
            fxFlex="20%" 
            (click)="cancelar()">
            Cancelar
    </button>

</div>
    </form>


</div>








